import React from "react";
import styled from "styled-components";
import CustomerBadges from "../../shared/CustomerBadges";
import HeaderPromo from "./HeaderPromo";
import useBadges from "../../../react-hooks/useBadges";

const InfoHeader = () => {
  const [badges, isLoading] = useBadges();

  return (
    <InfoHeaderContainer>
      {isLoading
        ? <></>
        : badges.length === 0
          ? <HeaderPromo/>
          : <CustomerBadges/>
      }
    </InfoHeaderContainer>
  );
};

export default InfoHeader;

const InfoHeaderContainer = styled.div`
  background: #ffffff;
  color: #333333;
  padding: 10px 0;
  font-size: 11px;
  height: 38px;
  width: 100%;
  max-width: 1160px;
  font-weight: 900;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: row;
  margin-right: auto;
  margin-left: auto;
  
  a {
    color: #333333;
    text-decoration: none;
  }
`;
